/**
 * Cleanup utility to remove old tokens from localStorage
 * 
 * SECURITY: After migrating to cookie-based authentication, old tokens
 * stored in localStorage should be removed to prevent XSS attacks.
 * 
 * Call this function on app initialization to clean up any leftover tokens.
 */

import logger from './logger'

export function cleanupOldTokens(): void {
  if (typeof window === 'undefined') return

  // List of old token keys that should be removed
  const oldTokenKeys = [
    'token',
    'authToken',
    'teacherToken',
    // Add any other token-related keys here
  ]

  let cleaned = false
  oldTokenKeys.forEach((key) => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key)
      cleaned = true
      logger.warn(`🧹 Cleaned up old token from localStorage: ${key}`)
    }
  })

  if (cleaned) {
    logger.info('✅ Old tokens cleaned up. Tokens are now stored in HTTP-only cookies for security.')
  }
}

/**
 * Check if old tokens exist in localStorage
 * Useful for debugging or migration verification
 */
export function hasOldTokens(): boolean {
  if (typeof window === 'undefined') return false

  const oldTokenKeys = ['token', 'authToken', 'teacherToken']
  return oldTokenKeys.some((key) => localStorage.getItem(key) !== null)
}

